import React, { useState, useEffect, useRef } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../../services/config";
import { Table, Modal, Spinner } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import ReactToPrint from "react-to-print";
import { useAlert } from "react-alert";
import Select from "react-select";
import PrintSchoolInvoice from "../PrintSchoolInvoice/PrintSchoolInvoice";
import { DatePicker } from "antd";
import { BiMoneyWithdraw } from "react-icons/bi";
import { MdDelete } from "react-icons/md";

const InvoiceList = () => {
  const { RangePicker } = DatePicker;
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setLoading] = useState(false);

  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [allsessions, setallsessions] = useState([]);
  const [currentsession, setcurrentsession] = useState("");
  const [showResult, setShowResult] = useState(false);
  const alert = useAlert();
  const pageStyle = `
  @page {
    size: A4 portrait !important;
  }
  `;
  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setMainCheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const banksloaded = useRef(false);

  const [schoolAccountData, setSchoolAccountData] = useState([]);
  const [schoolAccountId, setSchoolAccountId] = useState("");
  const [searchInvoice, setSearchInvoice] = useState("");
  const [monthlyInputsValue, setMonthlyInputsValue] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [allInvoicesList, setAllInvoicesList] = useState([]);
  const [rawInvoices, setRawInvoices] = useState([]);
  const [allSubAccounts, setAllSubAccounts] = useState([]);
  const [isCombine, setIsCombine] = useState(false);

  const [viewModal, setViewModal] = useState(false);
  const [selectedSchoolInvoice, setSelectedSchoolInvoice] = useState([]);

  const [payModal, setPayModal] = useState(false);
  const [selectedPayInvoice, setSelectedPayInvoice] = useState({});
  const [payInvoiceSubAccount, setPayInvoiceSubAccount] = useState("");
  const [payInvoiceAmount, setPayInvoiceAmount] = useState(0);
  const [paySessionId, setPaySessionId] = useState("");
  const [files, setFiles] = useState([]);
  const MAX_SIZE = 100 * 1024; // 100 KB

  const [editInvoiceModal, setEditInvoiceModal] = useState(false);
  const [editInvoiceMonth, setEditInvoiceMonth] = useState("");
  const [editInvoiceDueDate, setEditInvoiceDueDate] = useState("");
  const [editInvoiceIssueDate, setEditInvoiceIssueDate] = useState("");
  const [editInvoiceId, setEditInvoiceId] = useState("");

  const [editInvoiceDetailModal, setEditInvoiceDetailModal] = useState(false);
  const [editDetailAmount, setEditDetailAmount] = useState(0);
  const [editInvoiceDetailId, setEditInvoiceDetailId] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const [viewPaymentModal, setViewPaymentModal] = useState(false);
  const [editInvoicePayModal, setEditInvoicePayModal] = useState(false);
  const [editPayAmount, setEditPayAmount] = useState(0);
  const [editFiles, setEditFiles] = useState([]);
  const [editPaySubAccountId, setEditPaySubAccountId] = useState("");
  const [editInvoicePayId, setEditInvoicePayId] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletePayInvoiceId, setDeletePayInvoiceId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);

  const statusColorMap = {
    4: "green",
    3: "orange",
    2: "red",
    1: "black",
  };

  const statusMap = {
    4: "Paid",
    3: "In Process",
    2: "Partially Paid",
    1: "Unpaid",
  };

  const statusArray = [
    {
      label: "Unpaid",
      value: 1,
    },
    {
      label: "Partially Paid",
      value: 2,
    },
    {
      label: "In Process",
      value: 3,
    },
    {
      label: "Paid",
      value: 4,
    },
  ];

  useEffect(() => {
    if (!banksloaded.current) {
      banksloaded.current = true;
      getAllSessions();
      getSchoolAccounts();
      getBanksSubAccounts();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      // setSelectedChallans([]);
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);
  // }, []);

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
  };

  const handleChanger = (day, date) => {
    let startDate = date[0] + "-01";
    let endDate = date[1] + "-01";
    var start = startDate.split("-");
    var end = endDate.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        var month = j + 1;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth, "01"].join("-"));
      }
    }
    setMonthlyInputsValue(dates);
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setcurrentsession(session.id);
            setPaySessionId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changesession = (id) => {
    setcurrentsession(id);
  };

  const getSchoolAccounts = async () => {
    await fetch(`${baseUrl}/school-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          if (!data.metadata.success) {
            alert.error(data.metadata.message);
            return;
          } else {
            setSchoolAccountData(data.payload);
          }
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getBanksSubAccounts = async () => {
    await fetch(`${baseUrl}/bank-and-cash-sub-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [];
          data.payload.forEach((element) => {
            arr.push({
              label: element.title + `(${element.acode})`,
              value: element.id,
            });
          });
          setAllSubAccounts(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getInvoices = () => {
    if (currentsession == "") {
      alert.error("Please Select Session");
      return;
    }

    setLoading(true);

    const data = {
      session_id: currentsession,
      school_account_id: schoolAccountId,
      invoice_number: searchInvoice,
      months: monthlyInputsValue,
      payment_status: paymentStatus,
    };

    fetch(`${baseUrl}/search-invoices`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data?.payload?.length == 0) {
            setSelectedChallans([]);
            setAllInvoicesList([]);
            setRawInvoices([]);
          }
          const invoices = data.payload || [];
          setRawInvoices(invoices);
          setAllInvoicesList(
            isCombine ? combineInvoicesBySchool(invoices) : invoices,
          );

          searchClicked.current = true;
          setLoading(false);
          setShowResult(true);
        } else {
          alert.error(data.metadata.message);
          setSelectedChallans([]);
          setAllInvoicesList([]);
          setRawInvoices([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const combineInvoicesBySchool = (invoices) => {
    const grouped = invoices.reduce((acc, invoice) => {
      if (invoice.payment_status === 4) return acc;

      const schoolId = invoice.school_account?.id;
      const schoolName = invoice.school_account?.school_name;
      const regionName = invoice.school_account?.region?.name;

      if (!schoolId) return acc;

      if (!acc[schoolId]) {
        acc[schoolId] = {
          school_id: schoolId,
          school_name: schoolName,
          region_name: regionName,
          invoices: [],
          total_invoices: 0,
          total_payable: 0,
          total_paid: 0,
          total_balance: 0,
        };
      }

      acc[schoolId].invoices.push(invoice);
      acc[schoolId].total_invoices += 1;
      acc[schoolId].total_payable += Number(invoice.payable || 0);
      acc[schoolId].total_paid += Number(invoice.paid || 0);
      acc[schoolId].total_balance += Number(invoice.balance || 0);

      return acc;
    }, {});
    return Object.values(grouped);
  };

  useEffect(() => {
    if (!rawInvoices.length) return;

    setAllInvoicesList(
      isCombine ? combineInvoicesBySchool(rawInvoices) : rawInvoices,
    );
    searchClicked.current = true;
  }, [isCombine, rawInvoices]);

  const gotoViewModal = (invoice) => {
    setSelectedSchoolInvoice(invoice);
    // setSelectedPaymnetInvoice(invoice?.invoice_payments);
    setViewModal(true);
  };

  const gotoPaymentModal = (invoice) => {
    setSelectedSchoolInvoice(invoice);
    setViewPaymentModal(true);
  };

  const gotoEditModal = (invoice) => {
    setSelectedSchoolInvoice(invoice);
    setEditInvoiceId(invoice?.id);
    setEditInvoiceMonth(invoice?.month?.slice(0, 7) ?? "");
    setEditInvoiceDueDate(invoice?.due_date);
    setEditInvoiceIssueDate(invoice?.issue_date);
    setEditInvoiceModal(true);
  };

  const gotoPayModal = (invoice) => {
    setSelectedPayInvoice(invoice);
    setPayInvoiceAmount(invoice?.balance);
    setPayModal(true);
  };

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    var element = document.getElementById("hettingheight");

    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setMainCheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    allInvoicesList.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (allInvoicesList.length == selectedChallans.length) {
      setMainCheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setMainCheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (key) => {
    const updatedList = allInvoicesList.map((item) => {
      const isMatch = isCombine ? item.school_id === key : item.id === key;

      if (isMatch) {
        const updatedItem = { ...item, checked: !item.checked };

        if (updatedItem.checked) {
          AddSelectedChallan(updatedItem);
        } else {
          RemoveSelectedChallan(updatedItem);
        }

        return updatedItem;
      }

      return item;
    });

    setAllInvoicesList(updatedList);
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prev) => {
      const exists = prev.some((p) =>
        isCombine ? p.school_id === item.school_id : p.id === item.id,
      );

      if (exists) return prev;

      return [...prev, item];
    });
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prev) =>
      prev.filter((p) =>
        isCombine ? p.school_id !== item.school_id : p.id !== item.id,
      ),
    );
  };

  const updateInvoiceHandler = async () => {
    if (editInvoiceMonth == "") {
      return alert.error("Month Is Required");
    }

    if (editInvoiceDueDate == "") {
      return alert.error("Due Date Is Required");
    }

    if (editInvoiceIssueDate == "") {
      return alert.error("Issue Date Is Required");
    }

    setSubmitLoading(true);
    const data = {
      month: editInvoiceMonth + "-01",
      issue_date: editInvoiceIssueDate,
      due_date: editInvoiceDueDate,
    };

    await fetch(`${baseUrl}/invoices/${editInvoiceId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setSubmitLoading(false);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Invoice Successfully Updated");
            getInvoices();
            setEditInvoiceModal(false);
            setViewModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditInvoiceModal(false);
            setViewModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditInvoiceModal(false);
            setViewModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const payInvoiceHandler = async () => {
    if (paySessionId == "") {
      return alert.error("Please select a session for payment");
    }

    if (payInvoiceAmount <= 0) {
      return alert.error("Pay Amount must be greater than 0");
    }

    if (payInvoiceSubAccount == "") {
      return alert.error("Bank Account Is Required");
    }

    if (files[0] && files[0]?.size >= MAX_SIZE) {
      setPayModal(false);
      return alert.error("The image must not be greater than 100 kilobytes.");
    }

    const formData = new FormData();
    formData.append("year_id", paySessionId);
    formData.append("invoice_id", selectedPayInvoice?.id);
    formData.append("sub_account_id", payInvoiceSubAccount);
    formData.append("received_amount", payInvoiceAmount);
    files[0] && formData.append("image", files[0] ?? "");

    setSubmitLoading(true);
    await fetch(`${baseUrl}/invoice-payments`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setSubmitLoading(false);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Invoice Payment Successfully");
            setPayInvoiceAmount(0);
            setFiles([]);
            setPayInvoiceSubAccount("");
            setSelectedPayInvoice({});
            getInvoices();
            setPayModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setPayModal(false);
            setViewModal(false);
          } else {
            alert.show("Something Went Wrong");
            setPayModal(false);
            setViewModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const updateInvoiceDetailHandler = async () => {
    if (editDetailAmount == "") {
      return alert.error("Amount Is Required");
    }

    setUpdateLoading(true);
    const data = {
      session_id: currentsession,
      amount: editDetailAmount,
    };

    await fetch(`${baseUrl}/invoice-details/${editInvoiceDetailId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setUpdateLoading(false);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Invoice Detail Successfully Updated");
            setEditDetailAmount(0);
            setEditInvoiceDetailId("");
            getInvoices();
            setEditInvoiceDetailModal(false);
            setEditInvoiceModal(false);
            setViewModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditInvoiceDetailModal(false);
            setEditInvoiceModal(false);
            setViewModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditInvoiceDetailModal(false);
            setEditInvoiceModal(false);
            setViewModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setUpdateLoading(false);
      });
  };

  const updateInvoicePayHandler = async () => {
    if (editPayAmount == "") {
      return alert.error("Amount Is Required");
    }

    if (editFiles[0] && editFiles[0]?.size >= MAX_SIZE) {
      setEditInvoicePayModal(false);
      setViewPaymentModal(false);
      return alert.error("The image must not be greater than 100 kilobytes.");
    }

    const formData = new FormData();
    formData.append("_method", "PUT");
    formData.append("session_id", currentsession);
    formData.append("sub_account_id", editPaySubAccountId);
    formData.append("received_amount", editPayAmount);
    editFiles[0] && formData.append("image", editFiles[0] ?? "");

    setSubmitLoading(true);
    await fetch(`${baseUrl}/invoice-payments/${editInvoicePayId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setSubmitLoading(false);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Invoice Payment Successfully Updated");
            setEditPayAmount(0);
            setEditFiles([]);
            setEditInvoicePayId("");
            getInvoices();
            setEditInvoicePayModal(false);
            setViewPaymentModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditInvoicePayModal(false);
            setViewPaymentModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditInvoicePayModal(false);
            setViewPaymentModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deletePayInvoiceHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/invoice-payments/${deletePayInvoiceId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            getInvoices();
            setdeleteloading(false);
            setDeleteModal(false);
            setViewPaymentModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdeleteloading(false);
            setDeleteModal(false);
            setViewPaymentModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setDeleteModal(false);
            setViewPaymentModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setDeleteModal(false);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    // Replace existing file (single file only)
    setFiles([selectedFile]);

    // Reset input so same file can be reselected if removed
    event.target.value = "";
  };

  const removeImage = () => {
    setFiles([]);
  };
  const handleEditFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    // Replace existing file (single file only)
    setEditFiles([selectedFile]);

    // Reset input so same file can be reselected if removed
    event.target.value = "";
  };

  const downloadInvoicesPdf = async (invoices) => {
    setSubmitLoading(true);

    const data = {
      invoices: invoices,
      isCombine: isCombine,
    };

    try {
      const res = await fetch(`${baseUrl}/download-invoices`, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authtoken}`,
        },
        body: JSON.stringify(data),
      });

      if (!res.ok) {
        const error = await res.json();
        throw new Error(error?.message || "Download failed");
      }

      const blob = await res.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      const fileName =
        selectedChallans.length === 1
          ? "school-invoice.pdf"
          : "school-invoices.zip";

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert.error("Unable to download");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-3">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <select
              onChange={(e) => changesession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select School Account</b>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="schoolAccountId"
              value={schoolAccountId}
              onChange={(e) => setSchoolAccountId(e.target.value)}
              aria-label="Default select example"
            >
              <option value=""> Select School Account</option>
              {schoolAccountData.map((school, index) => (
                <option key={index} value={school.id}>
                  {school.school_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Enter Invoice Number</b>
            </label>
            <input
              onChange={(e) => setSearchInvoice(e.target.value)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  getInvoices();
                }
              }}
              className="form-control"
              placeholder="Enter Invoice Number"
            />
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Months</b>
            </label>
            <RangePicker
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
              style={{ height: "40px" }}
              picker="month"
              onChange={(day, date) => handleChanger(day, date)}
            />
          </div>

          <div className="col-md-6 mt-4">
            <label>
              <b>Select Status</b>
            </label>
            <Select
              onChange={(selectedOptions) =>
                setPaymentStatus(
                  selectedOptions
                    ? selectedOptions.map((opt) => opt.value)
                    : [],
                )
              }
              placeholder="Select Status"
              options={statusArray}
              isMulti
            />
          </div>

          <div className=" d-flex col-md-6 mt-13">
            <button
              type={"submit"}
              onClick={getInvoices}
              className="btn btn-primary mr-4"
            >
              Get Invoice
            </button>

            {showResult && allInvoicesList.length > 0 ? (
              <>
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle="Payment Invoice"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary"
                    >
                      {printloading ? "Printing..." : "Print Invoice"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <div className="mt-4">
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      checked={isCombine}
                      onChange={(e) => setIsCombine(e.target.checked)}
                    />
                    <span />
                    &nbsp;&nbsp;&nbsp;Combine Invoice
                  </label>
                </div>
              </>
            ) : null}
          </div>
          {showResult && allInvoicesList.length > 0 ? (
            <div className=" d-flex col-md-6 mt-5">
              <button
                className="btn btn-primary"
                onClick={() => downloadInvoicesPdf(selectedChallans)}
              >
                Download All
              </button>
            </div>
          ) : null}
        </div>

        <div
          className="table-responsive"
          style={{ maxHeight: "500px", overflowY: "auto" }}
        >
          <Table
            className="mt-5"
            style={{ width: `${isCombine}` ? "100%" : "120%" }}
          >
            <thead>
              <tr id="tbl">
                <th style={{ width: "5px" }}>
                  <label className="checkbox checkbox-single">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onClick={(e) => {
                        handleMainCheckboxClick();
                      }}
                      checked={mainCheckBoxChecked}
                    />
                    <span />
                  </label>
                </th>
                <th className="text-center">
                  {isCombine ? "Total Inoice" : "Actions"}
                </th>
                {isCombine ? null : (
                  <th className="text-center">Invoice No.</th>
                )}
                <th className="text-center">School Account</th>
                <th className="text-center">Region Name</th>
                {isCombine ? null : <th className="text-center">Month</th>}
                <th className="text-center">Payable</th>
                <th className="text-center">Paid</th>
                <th className="text-center">Balance</th>
                {isCombine ? null : <th className="text-center">Status</th>}
                {isCombine ? null : <th className="text-center">Due Date</th>}
                {isCombine ? null : <th className="text-center">Issue Date</th>}
              </tr>
            </thead>
            <tbody>
              {allInvoicesList &&
                allInvoicesList.map((invoice) => (
                  <tr
                    className="text-center"
                    style={{
                      color: `${isCombine}`
                        ? "black"
                        : statusColorMap[invoice?.payment_status],
                    }}
                  >
                    <td style={{ width: "5px" }}>
                      <label className="checkbox checkbox-single">
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          value={isCombine ? invoice.school_id : invoice.id}
                          onChange={(e) =>
                            handleChallansCheckBoxClick(
                              isCombine ? invoice.school_id : invoice.id,
                            )
                          }
                          checked={invoice.checked ?? false}
                        />
                        <span />
                      </label>
                    </td>
                    <td>
                      {isCombine ? (
                        invoice?.total_invoices
                      ) : (
                        <>
                          {invoice?.payment_status != "1" ? (
                            <a
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="View Invoice"
                              className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-2"
                              onClick={() => gotoPaymentModal(invoice)}
                              alt="View Invoice"
                            >
                              <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                                <SVG
                                  title="View Invoice"
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Devices/Display2.svg",
                                  )}
                                />
                              </span>
                            </a>
                          ) : null}

                          {invoice?.payable == invoice?.balance ? (
                            <a
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit Invoice"
                              className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-2"
                              onClick={() => {
                                gotoEditModal(invoice);
                              }}
                              alt="Edit Invoice"
                            >
                              <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                                <SVG
                                  title="Edit Invoice"
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Write.svg",
                                  )}
                                />
                              </span>
                            </a>
                          ) : null}

                          {invoice?.payment_status != "4" ? (
                            <>
                              <a
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Pay Invoice"
                                className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-2"
                                onClick={() => {
                                  gotoPayModal(invoice);
                                }}
                                alt="Pay Invoice"
                              >
                                <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                                  <BiMoneyWithdraw className="money-icon" />
                                </span>
                              </a>

                              <a
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Download Invoice"
                                className="btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                                onClick={() => {
                                  downloadInvoicesPdf([invoice]);
                                }}
                                alt="Download Invoice"
                              >
                                <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                                  <SVG
                                    title="Download Invoice"
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Devices/Printer.svg",
                                    )}
                                  />
                                </span>
                              </a>
                            </>
                          ) : null}
                        </>
                      )}
                    </td>
                    {isCombine ? null : <td>{invoice?.invoice_number}</td>}
                    <td>
                      {isCombine
                        ? invoice?.school_name
                        : invoice?.school_account?.school_name ??
                          invoice?.school_account_id}
                    </td>
                    <td>
                      {isCombine
                        ? invoice?.region_name
                        : invoice?.school_account?.region?.name ??
                          invoice?.school_account_id}
                    </td>
                    {isCombine ? null : <td>{getMonthName(invoice?.month)}</td>}
                    <td>
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_payable : invoice?.payable,
                      )}
                    </td>
                    <td>
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_paid : invoice?.paid,
                      )}
                    </td>
                    <td>
                      {Intl.NumberFormat("en-Us").format(
                        isCombine ? invoice?.total_balance : invoice?.balance,
                      )}
                    </td>
                    {isCombine ? null : (
                      <td>
                        <span
                          style={{
                            backgroundColor:
                              statusColorMap[invoice?.payment_status] ||
                              "black",
                            color: "white",
                            padding: "5px",
                            borderRadius: "5px",
                          }}
                        >
                          {statusMap[invoice?.payment_status]}
                        </span>
                      </td>
                    )}
                    {isCombine ? null : <td>{invoice?.due_date}</td>}
                    {isCombine ? null : <td>{invoice?.issue_date}</td>}
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : null}

        <Modal show={viewModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Invoice Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive>
              <thead>
                <tr id="tbl" className="text-center">
                  <th>Invoice ID</th>
                  <th>Royalty Sub Account</th>
                  <th>Description</th>
                  <th>Amount</th>
                  {selectedSchoolInvoice?.payable ==
                  selectedSchoolInvoice?.balance ? (
                    <th>Edit</th>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(selectedSchoolInvoice?.invoice_details) &&
                  selectedSchoolInvoice?.invoice_details.map((invoice) => (
                    <tr>
                      <td className="text-center">{invoice?.invoice_id}</td>
                      <td className="text-center">
                        {invoice?.royalty_sub_account?.title}
                      </td>
                      <td className="text-center">{invoice?.description}</td>
                      <td className="text-center">
                        {Intl.NumberFormat("en-Us").format(invoice?.amount)}
                      </td>
                      {selectedSchoolInvoice?.payable ==
                      selectedSchoolInvoice?.balance ? (
                        <td className="text-center">
                          <a
                            className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                            onClick={() => {
                              setEditInvoiceDetailId(invoice?.id);
                              setEditDetailAmount(invoice?.amount);
                              setEditInvoiceDetailModal(true);
                            }}
                          >
                            <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg",
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      ) : null}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <button
              onClick={() => setViewModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Invoice Modal */}
        <Modal show={editInvoiceModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Invoice
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-5">
              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>Invoice Month</b>
                </label>
                <input
                  onChange={(e) => setEditInvoiceMonth(e.target.value)}
                  type="month"
                  value={editInvoiceMonth}
                  class="form-control"
                />
              </div>
              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>Due Date</b>
                </label>
                <input
                  format="DD/MM/YYYY"
                  onChange={(e) => setEditInvoiceDueDate(e.target.value)}
                  type="date"
                  value={editInvoiceDueDate}
                  class="form-control"
                />
              </div>
              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>Issue Date</b>
                </label>
                <input
                  format="DD/MM/YYYY"
                  onChange={(e) => setEditInvoiceIssueDate(e.target.value)}
                  type="date"
                  value={editInvoiceIssueDate}
                  class="form-control"
                />
              </div>
            </div>

            <Table responsive>
              <thead>
                <tr id="tbl" className="text-center">
                  <th>Invoice ID</th>
                  <th>Royalty Sub Account</th>
                  <th>Description</th>
                  <th>Amount</th>
                  {selectedSchoolInvoice?.payable ==
                  selectedSchoolInvoice?.balance ? (
                    <th>Edit</th>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(selectedSchoolInvoice?.invoice_details) &&
                  selectedSchoolInvoice?.invoice_details.map((invoice) => (
                    <tr>
                      <td className="text-center">{invoice?.invoice_id}</td>
                      <td className="text-center">
                        {invoice?.royalty_sub_account?.title}
                      </td>
                      <td className="text-center">{invoice?.description}</td>
                      <td className="text-center">
                        {Intl.NumberFormat("en-Us").format(invoice?.amount)}
                      </td>
                      {selectedSchoolInvoice?.payable ==
                      selectedSchoolInvoice?.balance ? (
                        <td className="text-center">
                          <a
                            className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                            onClick={() => {
                              setEditInvoiceDetailId(invoice?.id);
                              setEditDetailAmount(invoice?.amount);
                              setEditInvoiceDetailModal(true);
                            }}
                          >
                            <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg",
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      ) : null}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateInvoiceHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditInvoiceModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Pay Invoice Modal */}
        <Modal show={payModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Pay Invoice
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Invoice No.</b>
                </label>
                <input
                  className="form-control"
                  value={selectedPayInvoice?.invoice_number}
                  disabled
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Payable Amount</b>
                </label>
                <input
                  className="form-control"
                  value={selectedPayInvoice?.payable}
                  disabled
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Paid Amount</b>
                </label>
                <input
                  className="form-control"
                  value={selectedPayInvoice?.paid}
                  disabled
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Remaining Balance Amount</b>
                </label>
                <input
                  className="form-control"
                  value={selectedPayInvoice?.balance}
                  disabled
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Select Session</b>
                </label>
                <select
                  onChange={(e) => setPaySessionId(e.target.value)}
                  className="form-select"
                  style={{ height: 40 }}
                  value={paySessionId}
                  aria-label="Default select example"
                >
                  <option value="">Select Session</option>
                  {allsessions.map((session, index) => (
                    <option key={index} value={session.id}>
                      {session.year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>
                    Enter Received Amount{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={payInvoiceAmount}
                  onChange={(e) => setPayInvoiceAmount(e.target.value)}
                  placeholder="Enter Received Amount"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>
                    Select Bank Account
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <Select
                  onChange={(e) => setPayInvoiceSubAccount(e.value)}
                  placeholder="Select Bank Account"
                  options={allSubAccounts}
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Upload Proof Image</b>
                </label>

                <input
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                  name="files"
                  accept=".jpg, .jpeg, .png, .gif, .svg"
                />

                {files.length > 0 && (
                  <ul className="mt-2">
                    <li>
                      {files[0].name}
                      <span
                        className="svg-icon svg-icon-md cursor-pointer ml-1"
                        onClick={removeImage}
                      >
                        <MdDelete color="#F64E60" />
                      </span>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={payInvoiceHandler} className="btn btn-primary">
                Pay Invoice
              </button>
            )}

            <button
              onClick={() => setPayModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Invoice Detail Modal */}
        <Modal show={editInvoiceDetailModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Invoice Detail
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Amount <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={editDetailAmount}
                onChange={(e) => setEditDetailAmount(e.target.value)}
                placeholder="Enter Amount"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {updateLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateInvoiceDetailHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditInvoiceDetailModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* View Invoice Payment Modal */}
        <Modal show={viewPaymentModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Invoice Payment Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive>
              <thead>
                <tr id="tbl" className="text-center">
                  <th>Invoice ID</th>
                  <th>Sub Account</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Proof</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(selectedSchoolInvoice?.invoice_payments) &&
                  selectedSchoolInvoice?.invoice_payments.map((invoice) => (
                    <tr>
                      <td className="text-center">{invoice?.invoice_id}</td>
                      <td className="text-center">
                        {invoice?.sub_account?.title} (
                        {invoice?.sub_account?.acode})
                      </td>
                      <td className="text-center">{"Paid Amount"}</td>
                      <td className="text-center">
                        {Intl.NumberFormat("en-Us").format(
                          invoice?.received_amount,
                        )}
                      </td>
                      <td className="text-center">
                        {invoice?.image_url != null ? (
                          <a
                            href={invoice.image_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={invoice.image_url}
                              alt="Payment Proof"
                              className="img-thumbnail"
                              style={{ maxWidth: "50px", cursor: "pointer" }}
                            />
                          </a>
                        ) : (
                          "---"
                        )}
                      </td>
                      {invoice?.voucher_id == null ? (
                        <td className="text-center">
                          <a
                            className="btn btn-icon btn-light btn-hover-primary-custom btn-sm"
                            onClick={() => {
                              setEditInvoicePayId(invoice?.id);
                              setEditPayAmount(invoice?.received_amount);
                              setEditPaySubAccountId(invoice?.sub_account_id);
                              setEditInvoicePayModal(true);
                            }}
                          >
                            <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg",
                                )}
                              />
                            </span>
                          </a>

                          <a
                            className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                            onClick={() => {
                              setDeletePayInvoiceId(invoice?.id);
                              setDeleteModal(true);
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Delete-user.svg",
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      ) : (
                        <td
                          style={{
                            color: "green",
                          }}
                        >
                          Paid
                        </td>
                      )}
                    </tr>
                  ))}
                {Array.isArray(selectedSchoolInvoice?.invoice_payments) &&
                selectedSchoolInvoice?.invoice_payments.length == 0 ? (
                  <tr>
                    <td className="text-center" colSpan="5">
                      No Payment Found
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <button
              onClick={() => setViewPaymentModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Invoice Payment Modal */}
        <Modal show={editInvoicePayModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Invoice Payment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>
                    Enter Amount <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editPayAmount}
                  onChange={(e) => setEditPayAmount(e.target.value)}
                  placeholder="Enter Amount"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>
                    Select Sub Account
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <Select
                  value={
                    allSubAccounts?.find(
                      (opt) => opt.value == editPaySubAccountId,
                    ) || ""
                  }
                  onChange={(e) => setEditPaySubAccountId(e.value)}
                  placeholder="Select Sub Account"
                  options={allSubAccounts}
                />
              </div>

              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>Upload Proof Image</b>
                </label>

                <input
                  type="file"
                  className="form-control"
                  onChange={handleEditFileChange}
                  name="editFiles"
                  accept=".jpg, .jpeg, .png, .gif, .svg"
                />

                {editFiles.length > 0 && (
                  <ul className="mt-2">
                    <li>
                      {editFiles[0].name}
                      <span
                        className="svg-icon svg-icon-md cursor-pointer ml-1"
                        onClick={() => setEditFiles([])}
                      >
                        <MdDelete color="#F64E60" />
                      </span>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateInvoicePayHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditInvoicePayModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Invoice Payment Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this invoice payment?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Invoice Payment Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deletePayInvoiceHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setDeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>

        {/* Print Invoice */}
        <div
          ref={componentRef}
          id="printSection"
          style={{ visibility: "hidden" }}
        >
          <PrintSchoolInvoice
            allInvoicesList={
              allInvoicesList.length == selectedChallans.length
                ? allInvoicesList
                : selectedChallans
            }
            isCombine={isCombine}
          />
        </div>
      </Paper>
    </div>
  );
};

export default InvoiceList;
